<template>
  <QuadroPrincipal borderTop :titulo="titulo" :classe="classe">
    <ImpostoSemResultado :titulo="titulo" />
  </QuadroPrincipal>
</template>

<script>
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";

export default {
  name: "MultiplosSemResultado",
  props: {
    classe: String,
    titulo: String
  },
  components: { ImpostoSemResultado, QuadroPrincipal }
};
</script>

<style lang="scss" scoped></style>
